var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BaseTaskPayload } from './base-payload';
var ProcedureTaskPayload = /** @class */ (function (_super) {
    __extends(ProcedureTaskPayload, _super);
    function ProcedureTaskPayload(taskCt, procedureHashid, nodeMap, orderedIds, calculateProgressUpdated) {
        var _this = _super.call(this, calculateProgressUpdated) || this;
        _this.taskCt = taskCt;
        _this.procedureHashid = procedureHashid;
        _this.nodeMap = nodeMap;
        _this.orderedIds = orderedIds;
        return _this;
    }
    ProcedureTaskPayload.prototype.toUpdateStep = function (stepId, payload) {
        return this.toUpdateProcedure(this.procedureHashid, {
            steps: [
                __assign(__assign({}, payload), { id: stepId, step: this.orderedIds.indexOf(stepId) }),
            ],
        });
    };
    ProcedureTaskPayload.prototype.toUpdateStepField = function (stepId, fieldId, value) {
        return this.toUpdateStep(stepId, {
            set_field: { id: fieldId, value: value },
        });
    };
    ProcedureTaskPayload.prototype.toSetStepCompleted = function (stepId, completed, choice) {
        if (choice === void 0) { choice = null; }
        var payload = {
            set_completed: this.getCompletedValueFor(completed),
        };
        var node = this.nodeMap[stepId];
        if (node.type === 'decision') {
            if (choice == null && completed) {
                throw Error("Decision step needs a choice value to be marked as completed. stepId: ".concat(stepId));
            }
            payload['set_choice'] = completed ? choice : null;
        }
        return this.toUpdateStep(stepId, payload);
    };
    /* It can be:
    - payload to set the task completed
    - payload to set a specific procedure sub-task completed
     */
    ProcedureTaskPayload.prototype.toSetCompleted = function (completed) {
        var payload = this.toSetProcedureCompleted(this.procedureHashid, completed);
        if (this.taskCt === 'procedure') {
            payload = __assign(__assign({}, payload), this.toSetTaskCompleted(completed));
        }
        return payload;
    };
    return ProcedureTaskPayload;
}(BaseTaskPayload));
export { ProcedureTaskPayload };
